import LogoutButton from "./logout-button.container";

export default LogoutButton